"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleErrors = handleErrors;
exports.initErrorReporting = initErrorReporting;
exports.logError = logError;
exports.logMessage = logMessage;
exports.setExtraContext = setExtraContext;
exports.setTagsContext = setTagsContext;
exports.setUserContext = setUserContext;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Checks the response header content type
 * @param {Response} response
 * @param {String} type
 * @return {Boolean}
 */
function hasContentType(response, type) {
  var contentType = response.headers.get('content-type');
  return contentType ? contentType.includes(type) : false;
}

/**
 * Parse a JSON response when body is not empty.
 *
 * @param {Response} response
 * @return {Promise}
 */
function parseJSONResponse(response) {
  return response.text().then(function (text) {
    return text ? JSON.parse(text) : {};
  });
}

/**
 * Gracefull failing logger.
 * @param {Error} error
 * @param {Object} extra Additional Information to be sent to Sentry
 * @param {Boolean} skipConsole Hides the error from the devTools console
 * @return {Void}
 */
function logError(error, extra, skipConsole) {
  /* eslint-disable no-console */
  if (!skipConsole && console && console.error) {
    console.error(error);
  }
  /* eslint-enable no-console */
}

/**
 * Send Messages to Sentry and log them in the Console
 * @param {String} msg
 * @param {Object} extra Additional Information to be sent to Sentry
 * @param {Boolean} skipConsole Hides the message from the devTools console
 * @return {Void}
 */
function logMessage(msg, extra, skipConsole) {
  /* eslint-disable no-console */
  if (!skipConsole && console && console.log) {
    console.log(msg);
  }
  /* eslint-enable no-console */
}

/**
 * While a user is logged in, you can tell Sentry to associate errors with user data.
 * Call with no arguments to reset.
 * @param {Object} context Context can include: email, id, username, ip_address
 * @return {Void}
 */
function setUserContext(context) {}

/**
 * Associate extra data to be merged with all events.
 * Call with no arguments to reset.
 * @param {Object} context Extra context to be merged with events
 * @return {Void}
 */
function setExtraContext(context) {}

/**
 * Associate tags to be merged with all events.
 * These tags are indexed and available to be searched on through Sentry.
 * @param {Object} context Key/value pairs which generate breakdowns charts and search filters
 * @return {Void}
 */
function setTagsContext(context) {}

/**
 * Send Error Reports to Sentry on failed Fetch responses.
 * @param {Response} response
 * @param {Boolean} returnResponse For valid responses it parses it to json for you.
 * @return {Promise}
 */
function handleErrors(response, returnResponse) {
  var isJSONResponse = hasContentType(response, 'application/json');

  // If the response is ok just keep going
  if (response.status >= 100 && response.status < 400) {
    if (returnResponse) {
      return Promise.resolve(response);
    }
    return isJSONResponse ? parseJSONResponse(response) : Promise.resolve(response.statusText || response.status);
  }

  // Response is not OK
  return new Promise(function (resolve, reject) {
    var errorResponse = isJSONResponse ? parseJSONResponse(response) : Promise.resolve({});
    errorResponse.then(function (extraData) {
      var requestId = response.headers.get('x-http-request-id');
      var message = "Endpoint Error: ".concat(response.status, " ").concat(response.statusText);

      // actually send the error to the error logging vendor, Sentry.
      logError(message, {
        serviceError: _objectSpread(_objectSpread({}, extraData), {}, {
          requestId: requestId
        })
      }, true);

      // reject the promise to go to the catch statement and pass it all the error data
      reject(returnResponse ? response : {
        extraData: extraData,
        status: response.status,
        statusText: response.statusText
      });
    });
  });
}

/**
 * Initialize the Error Reporting
 * @param {Object} config Check Configuration Options
 * @return {Void}
 */
function initErrorReporting(config) {
  // Promise unhandled rejections
  window.onunhandledrejection = function (evt) {
    // Do not show error in the console.
    logError(evt.reason, null, true);
  };
}
